import React from "react";
import Navbar from "./Navbar";
// import Row from "./MynftRow";
import Row from "./MyAssetNftRow";


function Mynfts(){
    return(
        <div>
            <Navbar/>
            <Row/>
        </div>
    )
}

export default Mynfts;